import { apiClient } from "@/lib/api-client"
import {
  TaskCompletionData,
  TaskActionRequest,
  AddCommentRequest,
  TaskCompletionResponse,
  TaskTokenValidationDto,
} from "../dto/taskCompletionDto"

export const getTaskByToken = async (
  token: string,
): Promise<TaskCompletionData> => {
  const response = await apiClient.get<TaskTokenValidationDto>(
    `/workflow-tasks/validate-token?token=${encodeURIComponent(token)}`,
  )
  const validation = response.data

  if (!validation.task) {
    throw new Error(validation.errorMessage || "Invalid or expired token")
  }

  const task = validation.task
  return {
    id: task.id,
    title: task.title,
    description: task.description,
    assignedToEmail: task.assignedToEmail,
    organizationName: task.organizationName || "Organisation",
    workflowName: task.workflowName || "Workflow",
    dueDate: task.duedate || "",
    status: task.status as "Pending" | "Completed" | "Declined" | "Expired",
    canComplete: validation.isValid && task.status === "Pending",
    canDecline: validation.isValid && task.status === "Pending",
    comments: task.comments ?? [],
    completedAt: task.completedAt,
    declinedAt: task.declinedAt,
  }
}

export const completeTask = async (
  token: string,
  request: TaskActionRequest,
  captchaToken: string = "",
): Promise<TaskCompletionResponse> => {
  const response = await apiClient.post(
    `/workflow-tasks/complete`,
    {
      Token: token,
      NewStatus: 1, // WorkflowTaskStatus.Completed
      Notes: request.notes,
      CaptchaToken: captchaToken,
    },
    { headers: { "Content-Type": "application/json" } },
  )
  return {
    success: true,
    message: "Task completed successfully",
    data: response.data,
  }
}

export const declineTask = async (
  token: string,
  request: TaskActionRequest,
  captchaToken: string = "",
): Promise<TaskCompletionResponse> => {
  const response = await apiClient.post(
    `/workflow-tasks/complete`,
    {
      Token: token,
      NewStatus: 2, // WorkflowTaskStatus.Declined
      Notes: request.notes,
      CaptchaToken: captchaToken,
    },
    { headers: { "Content-Type": "application/json" } },
  )
  return {
    success: true,
    message: "Task declined successfully",
    data: response.data,
  }
}

export const addComment = async (
  token: string,
  request: AddCommentRequest,
  captchaToken: string = "",
): Promise<TaskCompletionResponse> => {
  const response = await apiClient.post(
    `/workflow-tasks/comment`,
    {
      Token: token,
      Text: request.text,
      CaptchaToken: captchaToken,
    },
    { headers: { "Content-Type": "application/json" } },
  )
  return {
    success: true,
    message: "Comment added successfully",
    data: response.data,
  }
}